<template>
  <div class="custom-options">
    <div class="custom-options-content">
      <template v-if="optionsConfig.customTitle">
        <div class="content-title">
          {{ optionsConfig.customTitle }}
        </div>
      </template>
      <div class="pick-l" v-if="optionsConfig && optionsConfig.type" :key="valueKey">
        <template v-if="optionsConfig.type === 'pick'">
          <template v-for="it in optionsConfig.config" :key="it.name">
            <el-radio v-model="value" @change="changeValue" :label="it.name" />
          </template>
        </template>
        <div v-else-if="optionsConfig.type === 'checkbox'" class="xing-lll">
          <template v-for="it in optionsConfig.config" :key="it.name">
            <el-checkbox v-model="value" @change="changeValue" :label="it.name" />
          </template>
        </div>
        <div v-else>
          <template v-for="it in optionsConfig.config">
            <i :key="it.i" v-if="isAppenBtn(it.name, colIdx, rowIdx)" :class="['iconfont icon-xingxing xing', value >= it.name ? 'xing-active' : '']" @click.stop="changeValue(it)" />
          </template>
        </div>
      </div>
      <template v-else>
        未设置
      </template>
    </div>
  </div>
</template>

<script>
export default {
  // 组件名称
  name: 'optionsComp',
  // 组件参数 接收来自父组件的数据
  props: {
    config: {
      type: Object,
      default: () => ({})
    },
    optionsConfig: {
      type: Object,
      default: () => ({})
    },
    isAppenBtn: {
      type: Function,
      default: () => true
    },
    val: {
      type: [String, Number, Boolean, Array],
      default: ''
    },
    valueKey: {
      type: String,
      default: ''
    },
  },
  // 组件状态值
  data() {
    return {
      value: ''
    }
  },
  mounted() {
    if (this.optionsConfig && this.optionsConfig.defaultVal) {
      this.value = this.optionsConfig.defaultVal
      this.$emit('change', { value: this.optionsConfig.defaultVal, valueKey: this.valueKey })
    }
  },
  watch: {
    'optionsConfig.defaultVal': {
      handler(val) {
        if (val) {
          this.value = val
          this.$emit('change', { value: val, valueKey: this.valueKey })
        }
      },
      deep: true,
    },
  },
  // 组件方法
  methods: {
    changeValue(val) {
      this.$emit('change', { value: val, valueKey: this.valueKey })
    },
  },
}
</script>

<style scoped lang="scss">
.custom-options {
  &-content {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    .content-title {
      margin-bottom: 5px;
    }
  }
}
</style>